import { ConvertedComponentData } from '../../../cms/components/types'
import { InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { TrainingCategoryData } from '../training-category'

export interface TrainingFacetComponentData extends ConvertedComponentData {
  categories: TrainingCategoryData[];
}

export const TRAINING_FACET_CONVERTER =
  new InjectionToken<Converter<CmsComponent, TrainingFacetComponentData>[]>('TrainingFacetConverter')

